/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import {Add, Remove} from '@mui/icons-material'
import {useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Preguntas = ({item}) => {
    const {sCell} = useResponsive()
    const [open, setOpen] = useState(false)

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 1,
                border: 0.5,
                borderColor: '#ffffff50',
                background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
                backdropFilter: 'blur(5px)',
                color: '#fff',
                p: 3
            }}
        >


            <Grid container size={{xs: 10, sm: 11, md: 11}} sx={{justifyContent: 'flex-start', mb: -1}}>
                <Typography sx={{fontSize: sCell ? 16 : 20, fontWeight: 600, textAlign: 'left'}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 2, sm: 1, md: 1}} sx={{justifyContent: 'flex-end', mb: -0.5}}>
                <IconButton
                    onClick={() => setOpen(!open)}
                >
                    {open ?
                        <Remove sx={{fill: '#fff', mt: -1}}/>
                        :
                        <Add sx={{fill: '#fff', mt: -1}}/>
                    }
                </IconButton>
            </Grid>

            <Collapse sx={{width: '100%'}} in={open} >
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: 'left'}}>
                        {item.descripcion}
                    </Typography>
                </Grid>
            </Collapse>


        </Grid>
    )

}
export default Tarjeta_Preguntas